// extracted by mini-css-extract-plugin
export var darkMode = "_1g-0";